export default __webpack_public_path__ + "static/media/python-for-data-science-and-ai.f31784fc.png";